var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1152,
    zoomAndPan: "magnify",
    viewBox: "0 0 864 863.999991",
    height: 1152,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3e2ef892a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.789062 17.789062 L 846.210938 17.789062 L 846.210938 846.210938 L 17.789062 846.210938 Z M 17.789062 17.789062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b28b48833a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 432 17.789062 C 203.238281 17.789062 17.789062 203.238281 17.789062 432 C 17.789062 660.761719 203.238281 846.210938 432 846.210938 C 660.761719 846.210938 846.210938 660.761719 846.210938 432 C 846.210938 203.238281 660.761719 17.789062 432 17.789062 Z M 432 17.789062 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3e2ef892a2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b28b48833a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f1f1f1",
    d: "M 17.789062 17.789062 L 846.210938 17.789062 L 846.210938 846.210938 L 17.789062 846.210938 Z M 17.789062 17.789062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 17.788238, 17.788261)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 552.282378 0.00106824 C 247.266737 0.00106824 0.00109903 247.266706 0.00109903 552.282347 C 0.00109903 857.297988 247.266737 1104.563625 552.282378 1104.563625 C 857.298018 1104.563625 1104.563656 857.297988 1104.563656 552.282347 C 1104.563656 247.266706 857.298018 0.00106824 552.282378 0.00106824 Z M 552.282378 0.00106824 ",
    stroke: "#b8b8b8",
    strokeWidth: 130,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbb4e",
    d: "M 567.222656 495.851562 C 565.152344 497.871094 564.203125 500.78125 564.695312 503.632812 L 592.039062 663.078125 C 593.273438 670.265625 585.734375 675.742188 579.28125 672.351562 L 436.089844 597.070312 C 433.527344 595.722656 430.46875 595.722656 427.90625 597.070312 L 284.714844 672.351562 C 278.261719 675.742188 270.722656 670.265625 271.953125 663.078125 L 299.300781 503.632812 C 299.789062 500.78125 298.84375 497.871094 296.773438 495.851562 L 180.925781 382.929688 C 175.707031 377.84375 178.589844 368.976562 185.800781 367.929688 L 345.894531 344.667969 C 348.757812 344.25 351.234375 342.453125 352.515625 339.855469 L 424.109375 194.789062 C 427.335938 188.25 436.65625 188.25 439.882812 194.789062 L 511.480469 339.855469 C 512.761719 342.453125 515.238281 344.25 518.101562 344.667969 L 678.191406 367.929688 C 685.40625 368.976562 688.285156 377.84375 683.066406 382.929688 Z M 567.222656 495.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.f55f4e613031c3838aa236336ea29963.svg";
export { ForwardRef as ReactComponent };